import { createRoot } from "react-dom/client";
import React from "react";
import App from "./App.tsx";
import "./styles/global.css";
import "./i18n/config";
import { bootstrapHashRouterFromPathname } from "./hashRouterBootstrap";
import { applyMenuEngineFromUrl } from "./lib/utils/serverMenuOptIn";
import { applyAssistantOptInFromUrl } from "./lib/utils/assistantOptIn";
import { watchForServiceWorkerUpdate } from "./pwa/serviceWorkerUpdate";

// Initialize Sentry lazily — keeps it out of the critical render path
import("./lib/utils/sentry.ts").then(({ initSentry }) => initSentry());

// Read `?motor=` before the router rewrites the URL (per-browser opt-in to the server engine).
applyMenuEngineFromUrl();
applyAssistantOptInFromUrl();

// A deploy used to need two loads: the worker serves the precached shell until the page is reloaded
// after the new one takes over. This takes the first moment where a reload costs nothing.
watchForServiceWorkerUpdate();
bootstrapHashRouterFromPathname();

// Accessibility runtime checking in development
if (import.meta.env.DEV) {
  import("@axe-core/react").then((axe) => {
    axe.default(React, createRoot, 1000);
  });
}

// i18n is now bundled with the app, no need for Suspense
createRoot(document.getElementById("root")!).render(<App />);
